import {setIntent} from 'src/pages/scheduleCallback/store/actions/app';
import {appointmentCancelationConfirmationStep} from 'src/pages/scheduleCallback/store/actions/appointmentCancelationConfirmationStep';
import {errorStep} from 'src/pages/scheduleCallback/store/actions/errorStep';
import {
  DELETE_INTERACTION_ERROR,
  DELETE_INTERACTION_SUCCESS,
  deleteInteraction,
  LOAD_INTERACTIONS_ERROR,
  LOAD_INTERACTIONS_SUCCESS,
  loadInteractions,
} from 'src/pages/scheduleCallback/store/actions/interactions';
import {interactionsAppointment} from 'src/pages/scheduleCallback/store/selectors/app';
import {changeView} from 'src/shared/currentView/actions';
import {LOADING} from 'src/shared/currentView/commonViews';
import {waitForNextOneOf} from 'src/shared/events';

export const submitCancelAppointment = () => async (dispatch, getState) => {
  dispatch(changeView(LOADING));

  // The appointment id returned from createInteraction will result in a 404
  // when deleting an interaction, so we need to load the interactions to get the id
  let appointment = interactionsAppointment(getState());
  if (!appointment || !appointment.id) {
    dispatch(loadInteractions());
    await waitForNextOneOf([LOAD_INTERACTIONS_SUCCESS, LOAD_INTERACTIONS_ERROR]);
    appointment = interactionsAppointment(getState());
    if (!appointment || !appointment.id) {
      return dispatch(errorStep());
    }
  }

  dispatch(deleteInteraction(appointment.id));
  const {type} = await waitForNextOneOf([DELETE_INTERACTION_ERROR, DELETE_INTERACTION_SUCCESS]);
  if (type === DELETE_INTERACTION_ERROR) {
    return dispatch(errorStep());
  }
  dispatch(setIntent(''));
  dispatch(appointmentCancelationConfirmationStep());
};
